import { WebStorage, WebStorageNames, Common } from "../../../utils";
import { axiosBasic, getAuthToken, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import {
  LOGIN_FORM_CHANGED,
  LOGIN_FORM_CLEAR_ERROR,
  LOG_OUT,
  IS_LOADING
} from "./accountActionsTypes";

const { Account } = config.REST_API;
const {ROOT_URL}=config;
export const loginFormChanged = (prop, value) => ({
  type: LOGIN_FORM_CHANGED,
  payload: { prop, value }
});

export const isLoading = value => ({
  type: IS_LOADING,
  payload: value
});
export const logOut = () => ({
  type: LOG_OUT
});
const setUserdata = (userInfo, authData, isLoggedIn) => {
  WebStorage.setLocalStore(WebStorageNames.UserInfo, userInfo);
  WebStorage.setLocalStore(WebStorageNames.AuthInfo, authData);
  WebStorage.setLocalStore(WebStorageNames.UserLoggedIn, isLoggedIn);
};

export const onLoginUser = ({ email, password, navigation }) => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .post(ROOT_URL+Account.LogIn, {
      Email: email,
      Password: password,
      deviceRegistration: {
        deviceToken: email,
        platform: "WebApp",
      },
    })
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        dispatch(loginFormChanged("isLoggedIn", true));
        const { AccessToken, RefreshToken, Role } = data;
        const userInfo = {
          Role,
          email
        };
        const authData = { AccessToken, RefreshToken };
        setUserdata(userInfo, authData, true);
        navigation.push("/submitURL");
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onForgetPassword = ({ email, navigation }) => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .post(ROOT_URL+Account.ForgotPassword, {
      Email: email
    })
    .then(response => {
      const { success, message } = response.data;
      if (success) {
        Common.showSuccessMessage(message);
        navigation.push("/login");
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onSendMessage = values => {
  const obj = {
    Name: values.name,
    Subject: values.subject,
    Email: values.email,
    Message: values.message
  };
  return dispatch => {
    dispatch(isLoading(true));
    return axiosBasic
      .post(ROOT_URL+Account.ContactUs, obj)
      .then(response => {
        const { success, message } = response.data;
        if (success) {
          Common.showSuccessMessage(message);
        } else {
          Common.showErrorMessage(message);
        }
      })
      .catch(error => {
        Common.showErrorMessage(error);
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  };
};

export const onChangePassword = ({
  password,
  newPassword,
  confirmPassword
}) => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .post(ROOT_URL+Account.ChangePassword, {
      Password: password,
      NewPassword: newPassword,
      ConfirmNewPassword: confirmPassword
    })
    .then(response => {
      const { success, message } = response.data;
      if (success) {
        Common.showSuccessMessage(message);
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

export const onRegisterUser = ({
  name,
  email,
  password,
  navigation
}) => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .post(ROOT_URL+Account.Register, {
      Name: name,
      Email: email,
      Password: password,
      deviceRegistration: {
        deviceToken: email,
        platform: "WebApp",
      },
    })
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        dispatch(loginFormChanged("isLoggedIn", true));
        const { AccessToken, RefreshToken, Role } = data;
        const userInfo = {
          Role,
          email
        };
        const authData = { AccessToken, RefreshToken };
        setUserdata(userInfo, authData, true);
        Common.showSuccessMessage(message);
        navigation.push("/submitURL");
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    })
    .finally(() => {
      dispatch(isLoading(false));
    });
};

const clearStorage = navigation => {
  WebStorage.removeLocalStore(WebStorageNames.AuthInfo);
  WebStorage.removeLocalStore(WebStorageNames.UserInfo);
  WebStorage.removeLocalStore(WebStorageNames.UserLoggedIn);
  navigation.push("/");
};
export const onLogOut = navigation => dispatch => {
  dispatch(isLoading(true));
  const refreshToken= getAuthToken().RefreshToken;
  const email= getUserInfo().email;
  try {
    axiosBasic
      .get(ROOT_URL+`${Account.LogOff}?refreshToken=${refreshToken}&deviceToken=${email}`)
      .then(() => {
        dispatch(logOut());
        dispatch(loginFormChanged("isLoggedIn", false));
        clearStorage(navigation);
      })
      .catch(error => {
        console.log(error);
        dispatch(loginFormChanged("isLoggedIn", false));
        dispatch(logOut());
        clearStorage(navigation);
      })
      .finally(() => {
        dispatch(isLoading(false));
      });
  } catch (ex) {
    dispatch(logOut());
    dispatch(loginFormChanged("isLoggedIn", false));
    dispatch(isLoading(false));
    clearStorage(navigation);
  }
};
